import { menu_group_card } from "@/constants/menu";
export const getListMenuGroupCard = (type, key) => {
  return menu_group_card[key][type] || [];
};
